import userConstants from '../constants';

const initialState = {
  isSuperUser: false,
};

// eslint-disable-next-line default-param-last
export function superUser(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case userConstants.SET_SUPER_USER:
      return {
        isSuperUser: true,
      };
    default:
      return state;
  }
}
